export const getAllLoginErrors = (response): string[] => {
    const errors = [];
    response?.error?.response?.data?.errors?.email?.forEach((item) => errors.push(item));
    response?.error?.response?.data?.errors?.user?.forEach((item) => errors.push(item));
    return errors;
};
